<template>
  <div>
    <!-- 位置名称 动态 -->
    <bread-crumb :name="'名称'"></bread-crumb>
    <div
      style="flex-wrap: wrap; margin-left: 20px"
      v-if="floorLabelCode?.includes('wiki-input-business-label')"
    >
      <el-cascader
        v-model="selectedValues"
        :options="businessLabelList"
        :props="props"
        @change="handleCascaderChange"
        placeholder="请选择业务标签"
      ></el-cascader>
    </div>
    <manFormList
      :select="select"
      :selectList="selectList"
      @getChangeValue="getChangeValue"
      @editorial_remoteMethod="editorial_remoteMethod"
      @write_remoteMethod="write_remoteMethod"
      @empty="empty"
      :num="1"
      :isBtn="1"
    ></manFormList>
    <div class="wiki-audit-tabel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          v-for="(item, index) in jbbkTabList"
          :key="index"
        >
          <span slot="label" class="slot-item">
            <span>{{ item.title }}</span
            ><span>{{ item.count }}</span>
          </span>
          <div class="base-table">
            <div class="base-table-table">
              <el-table :data="jbbkList">
                <template v-for="(item, index) in colunmName">
                  <!-- contentId -->
                  <el-table-column
                    v-if="item.prop === 'contentId'"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                  />
                  <!-- icd -->
                  <el-table-column
                    v-if="item.prop === 'icd'"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.prop"
                  />
                  <!-- 百科名称 -->
                  <el-table-column
                    v-if="item.prop === 'contentName'"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.prop"
                  />
                  <!-- 部位 -->
                  <el-table-column
                    v-if="item.prop === 'bodyParts'"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.prop"
                  >
                    <template
                      slot-scope="scope"
                      v-if="
                        scope.row.bodyParts && scope.row.bodyParts.length > 0
                      "
                    >
                      <div
                        v-for="(item, index) in scope.row.bodyParts"
                        :key="index"
                      >
                        {{ item.name }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="item.prop === 'departments'"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.prop"
                  >
                    <template slot-scope="scope">
                      <span
                        v-for="(item, index) in scope.row.departments"
                        :key="index"
                      >
                        {{ item.departName
                        }}{{
                          index === scope.row.departments.length - 1 ? "" : "、"
                        }}
                      </span>
                    </template>
                  </el-table-column>
                  <!-- 创建人 -->
                  <el-table-column
                    v-if="item.prop === 'createUser'"
                    :label="item.label"
                    :key="index"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.createUser }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="item.prop === 'createTime'"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                  />
                  <el-table-column
                    v-if="item.prop === 'auditTime'"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.auditInfo.auditTime }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="item.prop === 'doctorInfos'"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                  >
                    <template
                      slot-scope="scope"
                      v-if="scope.row.doctorInfos.length > 0"
                    >
                      <span
                        v-for="(item, index) in scope.row.doctorInfos"
                        :key="index"
                      >
                        <span v-if="item.roleType == 1">
                          {{
                            item.docName +
                            " " +
                            item.titleName +
                            " " +
                            "ID: " +
                            item.departName +
                            " " +
                            item.hospitalGradeName +
                            " " +
                            item.hospitalName
                          }}
                        </span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="item.prop === 'auditUser'"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.auditInfo.auditUser }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="item.prop === 'auditDoctor'"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                  >
                    <template slot-scope="scope">
                      <div
                        v-html="doctorInfosOrDoctor(scope.row.doctorInfos)"
                      ></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="item.prop === 'auditStatus'"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                        effect="dark"
                        :content="scope.row.auditInfo.remark"
                        placement="top"
                        style="display: inline-block"
                        v-if="scope.row.auditInfo.auditStatus == 4"
                      >
                        <div
                          :class="
                            scope.row.auditInfo.auditStatus == 4
                              ? 'rejected'
                              : ''
                          "
                        >
                          {{ scope.row.auditInfo.auditStatus | auditStatus }}
                          <i class="el-icon-warning-outline"></i>
                        </div>
                      </el-tooltip>
                      <div v-else>
                        {{ scope.row.auditInfo.auditStatus | auditStatus }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="item.prop === 'contentStatus'"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                        effect="dark"
                        :content="reasonForOffline"
                        placement="top"
                        style="display: inline-block"
                        v-if="scope.row.contentStatus == 2"
                      >
                        <div
                          :class="
                            scope.row.contentStatus == 2 ? 'rejected' : ''
                          "
                          @mouseenter="remarkContent(scope)"
                        >
                          {{ scope.row.contentStatus | contentStatus }}
                          <i class="el-icon-warning-outline"></i>
                        </div>
                      </el-tooltip>
                      <div v-else>
                        {{ scope.row.contentStatus | contentStatus }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="item.prop === 'operate_md5'"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                  >
                    <template slot-scope="scope">
                      <div>
                        <el-button
                          type="text"
                          size="small"
                          v-if="scope.row.auditInfo.auditStatus == 2"
                          @click="toAuditPage(scope.row, item.route)"
                          >审核
                        </el-button>
                        <span
                          class="border"
                          v-if="
                            scope.row.auditInfo.auditStatus == 2 &&
                            scope.row.contentStatus == 1
                          "
                        ></span>
                        <el-button
                          type="text"
                          size="small"
                          v-if="
                            scope.row.auditInfo.auditStatus == 1
                              ? false
                              : scope.row.auditInfo.auditStatus == 2
                              ? false
                              : true
                          "
                          @click="toEditPage(scope.row, item.route)"
                          >编辑
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          v-if="
                            scope.row.auditInfo.auditStatus == 1 &&
                            scope.row.contentStatus == 2
                          "
                          @click="toEditPage(scope.row, item.route)"
                          >编辑
                        </el-button>
                        <span
                          class="border"
                          v-if="
                            scope.row.contentStatus == 1 &&
                            scope.row.auditInfo.auditStatus !== 2 &&
                            scope.row.auditInfo.auditStatus !== 1
                          "
                        ></span>
                        <el-button
                          type="text"
                          size="small"
                          v-if="
                            scope.row.contentStatus == 1 &&
                            scope.row.contentType != 37 &&
                            scope.row.contentType != 42
                          "
                          @click="articlePreview(scope.row, item.route)"
                          >查看线上
                        </el-button>
                        <span
                          class="border"
                          v-if="
                            scope.row.contentStatus == 1 &&
                            scope.row.contentType != 37 &&
                            scope.row.contentType != 42
                          "
                        ></span>
                        <el-button
                          type="text"
                          size="small"
                          @click="offlineDisease(scope.row)"
                          v-if="scope.row.contentStatus == 1"
                          >下线
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="btn-bar">
        <el-button
          type="text"
          style="margin-right: 10px"
          @click="showUploadData = true"
          >下载上传失败数据</el-button
        >
        <el-button
          type="primary"
          v-if="canUpdateData"
          @click="
            importExportCode = 12;
            showExportData = true;
          "
          >更新数据</el-button
        >
        <el-button
          type="primary"
          @click="
            importExportCode = 11;
            showExportData = true;
          "
          >批量导入数据</el-button
        >
      </div>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    />
    <!-- 批量导入模态框 -->
    <el-dialog
      :title="importExportCode === 11 ? '批量导入数据' : '批量更新数据'"
      :visible.sync="showExportData"
      width="560px"
      :before-close="handleExportDataClose"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <el-button type="primary" plain @click="downloadTemplate"
          >下载数据导入模板</el-button
        >
        <div
          style="
            display: flex;
            align-items: center;
            margin: 20px 0;
            width: 460px;
          "
        >
          <el-button @click="onSelectFile" :loading="isUploading"
            >选择文件</el-button
          >
          <label style="flex: 1; margin-left: 10px">{{
            exportFile ? formatFileName(exportFile.name) : "未选择任何文件"
          }}</label>
          <el-button type="primary" @click="onUploadFile" :loading="isUploading"
            >上传</el-button
          >
        </div>
        <div style="color: orange; width: 460px">
          注：1、请上传Excel文件，列表不要超过1000行<br />
          <span style="margin-left: 28px">2、上传过程中请勿刷新</span>
        </div>
      </div>
    </el-dialog>
    <!-- 下载上传失败数据模态框 -->
    <el-dialog
      title="下载上传失败数据"
      :visible.sync="showUploadData"
      width="360px"
      :before-close="handleUploadDataClose"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
        "
      >
        <span style="margin-right: 20px">导入失败数据下载</span>
        <el-button type="primary" plain size="small" @click="exportFailData(11)"
          >下载</el-button
        >
      </div>
      <div
        style="display: flex; align-items: center; justify-content: center"
        v-if="canUpdateData"
      >
        <span style="margin-right: 20px">更新失败数据下载</span>
        <el-button type="primary" plain size="small" @click="exportFailData(12)"
          >下载</el-button
        >
      </div>
    </el-dialog>
    <modal
      :isShow.sync="seeReasonDialog"
      title="查看理由"
      :isShowBtn="isShowBtn"
      @one="handleDialog(false)"
      @update:isShow="handleDialog(false)"
    >
      <div class="base-dialog">
        <el-form>
          <el-form-item label="理由" prop="nameValue"
            >{{ reason }}
          </el-form-item>
        </el-form>
      </div>
    </modal>
    <modal
      :isShow.sync="offlineDialog"
      title="下线"
      :width="width"
      :isShowBtn="isShowBtn"
      :btnText="['取消', '确认']"
      @clickHandler="offlineClickHandler"
    >
      <el-form :model="rejectForm" label-width="100px">
        <span class="red">*</span>
        <el-form-item label="下线理由" class="freezeDom">
          <el-input
            size="small"
            type="textarea"
            placeholder="请输入下线理由，不超过200字"
            v-model="offLineReasons"
            maxlength="200"
            show-word-limit
            class="freezeInp"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>
  </div>
</template>

<script>
import manFormList from "@/entrys/man/components/manFormList.vue";
import breadCrumb from "@/components/wiki/breadCrumb";
import pagination from "@/components/wiki/pagination";
import modal from "@/components/modal";
import { request } from "@/utils/axios";
import ArticleLabel from "@/components/select/ArticleLabel";
import { getDoctorInformation, healthCmpQueryBodyParts } from "@/api/man";

import {
  getReviewStatus,
  getDiseaseSymptoms,
  changgeDiseaseSymptomsOnline,
} from "@/api/symptomaticDisease";
import {
  getImportTemplate,
  importExportLog,
  importInArticleCategory,
} from "../../../../../api/man";

export default {
  name: "diseaseList",
  data() {
    return {
      // 疫苗百科
      contentType: this.$route.query.type,
      canUpdateData: ![
        "38",
        "13",
        "16",
        "17",
        "19",
        "20",
        "22",
        "31",
        "32",
        "33",
        "34",
      ].includes(this.$route.query.type),
      // 搜索
      selectList: {
        queryItem: "", // 输入疫苗ID
        selectDiseaseInfoId1: "", // 输入疫苗名称
        submissionTime: [], // 投稿时间
        contentStatus: "", // 问文章状态
        writeDoc: "",
        editorialDoctor: "", // 编审医生
        departmentName: [], // 科室名称
        businessLabel: [], // 自定义标签
      },
      select: [],
      // Tab
      activeName: "all",
      jbbkTabList: [
        {
          name: "all",
          title: "全部",
          count: 0,
          type: "allCount",
        },
        {
          name: "unaudit",
          title: "待审核",
          count: 0,
          type: "unAuditCount",
        },
        {
          name: "approved",
          title: "审核通过",
          count: 0,
          type: "passAuditCount",
        },
        {
          name: "rejected",
          title: "已驳回",
          count: 0,
          type: "rejectCount",
        },
      ],
      offLineReasons: "",
      offLineInfo: "",
      contentAuditStatusList: [1, 2, 3, 4],
      // 表格
      jbbkList: [],
      // 分列
      colunmName: [],
      // 分页
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      articleListCode: 0,
      seeReasonDialog: false, // 查看理由弹框
      isShowBtn: [true, true, false],
      offlineDialog: false,
      reason: "", //理由
      reasonForOffline: "",
      showExportData: false,
      showUploadData: false,
      exportFile: null,
      isUploading: false,
      importExportCode: 11, // 11-导入 12-更新
      businessLabelList: [], // 自定义标签列表
      selectedValues: [], // 选择自定义标签
      props: {
        value: "id", // 选项的值字段
        label: "name", // 选项的标签字段
        children: "contentLabels", // 子选项字段
        multiple: true,
        checkStrictly: true,
      },
      floorLabelCode: [], // 天空之城楼层
    };
  },
  components: {
    manFormList,
    breadCrumb,
    pagination,
    ArticleLabel,
    modal,
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        this.contentAuditStatusList = [1, 2, 3, 4];
        sessionStorage.setItem(
          "contentAuditStatus",
          this.contentAuditStatusList
        );
        this.paginationDataProduct.currentPage = 1;
        this.selectList.queryItem = "";
        this.selectList.businessLabel = "";
        this.selectList.selectDiseaseInfoId1 = "";
        this.selectList.selectedDeparttId = null;
        this.selectList.submissionTime = [];
        this.selectList.contentStatus = "";
        this.selectList.writeDoc = null;
        this.activeName = "all";
        this.auditStatus = [1, 2, 3, 4];
        this.select.map((item) => {
          if (item.prop == "writeDoc") {
            item.List = [];
          }
        });
        this.contentType = this.$route.query.type;
        this.info();
        this.canUpdateData = ![
          "38",
          "13",
          "16",
          "17",
          "19",
          "20",
          "22",
          "31",
          "32",
          "33",
          "34",
        ].includes(this.$route.query.type);
      },
      deep: true,
    },
  },
  created() {
    // 是否由文章详情页跳转本页面
    this.info();
  },
  destroyed() {
    // 销毁详情跳跳转存储
    sessionStorage.removeItem("commonwiki" + this.contentType);
  },
  filters: {
    auditStatus: function (data) {
      switch (data) {
        case 1:
          return "草稿";
        case 2:
          return "待审核";
        case 3:
          return "审核通过";
        case 4:
          return "已驳回";
      }
    },
    contentStatus: function (data) {
      switch (data) {
        case 1:
          return "已上线";
        case 2:
          return "已下线";
        default:
          return "";
      }
    },
  },
  methods: {
    // 初始化自定义标签
    formatData(data) {
      // 格式化数据为需要的结构
      return data.map((group) => ({
        id: group.id,
        name: group.name,
        contentLabels: group.contentLabels.map((label) => ({
          id: label.id,
          name: label.name,
          contentLabels: label?.contentLabels || null, // 处理三级标签
        })),
      }));
    },
    handleCascaderChange(value) {
      console.log(
        "选中的值:",
        value?.map((subArray) => subArray[subArray.length - 1])
      );
      this.selectList.businessLabel = value?.map(
        (subArray) => subArray[subArray.length - 1]
      );
    },
    info() {
      this.initializeJump();
      this.pageDiseaseInfoDraftList();
      this.getDiseaseDraftCountList();
      request("health_cmp_biz_pageAuditLabels", {
        tenantId: this.$commonJs.getTenantId(),
      })
        .then((res) => {
          this.businessLabelList = this.formatData(res.data || []);
        })
        .catch((err) => {});
      request("jdh_laputa_queryFloorList", {
        functionId: "manList" + this.$route.query.type,
        appId: "21557c5d3d0a4ec1b0184719022bb4b5",
        osName: "jdhwiki",
        venderId: null,
        inquiryTenancyId: null,
        version: 3,
      })
        .then((res) => {
          console.log("resres", res);
          this.select = res?.cf?.floorTransferDTOS.map((val) => {
            let obj = {};
            this.floorLabelCode = [...this.floorLabelCode, val.floorLabelCode];
            if (val.floorLabelCode == "wiki-input-id") {
              return (obj = {
                prop: "queryItem",
                type: "input",
                placeholder: JSON.parse(
                  val.cfgList.find((q) => q.name === "placeholder").value
                ),
              });
            } else if (val.floorLabelCode == "wiki-input-name") {
              return (obj = {
                prop: "selectDiseaseInfoId1",
                type: "input1",
                placeholder: JSON.parse(
                  val.cfgList.find((q) => q.name === "placeholder").value
                ),
              });
            } else if (val.floorLabelCode == "wiki-input-time") {
              return (obj = {
                prop: "submissionTime",
                type: "picker",
                placeholder: "请选择时间",
              });
            } else if (val.floorLabelCode == "wiki-input-department") {
              return (obj = {
                prop: "departmentName",
                type: "cascader",
                placeholder: "请输入科室名称",
              });
            } else if (val.floorLabelCode == "wiki-input-editorial-doctor") {
              return (obj = {
                prop: "editorialDoctor",
                type: "editorialDoctor",
                placeholder: "请输入编审医生",
                List: [],
              });
            } else if (val.floorLabelCode == "wiki-input-position") {
              return (obj = {
                prop: "selectedDeparttId",
                type: "select",
                placeholder: "请选择症状部位",
                List: [],
              });
            } else if (val.floorLabelCode == "wiki-input-writ-doctor") {
              return (obj = {
                prop: "writeDoc",
                type: "selectBus",
                placeholder: "请输入编写医生",
                List: [],
              });
            } else if (val.floorLabelCode == "wiki-input-status") {
              return (obj = {
                prop: "contentStatus",
                type: "select",
                placeholder: "请选择百科状态",
                cfgID: 4000,
                List: [
                  {
                    label: "全部",
                    value: "",
                  },
                  {
                    label: "已上线",
                    value: 1,
                  },
                  {
                    label: "已下线",
                    value: 2,
                  },
                ],
              });
            } else if (val.floorLabelCode == "wiki-input-write-doctor") {
              return (obj = {
                prop: "editorialDoctor",
                type: "editorialDoctor",
                placeholder: "请输入编审药师",
                List: [],
              });
            } else {
              return "";
            }
          });
          try {
            this.colunmName = JSON.parse(
              res.cf.floorTransferDTOS
                .filter((val) => val.floorLabelCode === "common-wiki-list")[0]
                .cfgList.filter((item) => item.name === "colunmName")[0].value
            );
            console.log(this.colunmName);
          } catch (error) {
            console.log(error);
          }
          this.healthCmpQueryBodyParts();
        })
        .catch((err) => {
          this.$message.error(err.msg || "查询失败");
        });
    },
    // 回到列表页 跳转
    initializeJump() {
      // 是否由文章详情回到列表页
      if (sessionStorage.getItem("commonwiki" + this.contentType)) {
        let contentStatus = sessionStorage.getItem("contentAuditStatus");
        let doctorList = JSON.parse(sessionStorage.getItem("writeDoc"));
        this.paginationDataProduct.currentPage =
          sessionStorage.getItem("currentPage");
        this.selectList = JSON.parse(sessionStorage.getItem("select"));
        this.activeName = sessionStorage.getItem("activeName");
        if (contentStatus == "1,2,3,4") {
          this.contentAuditStatusList = [1, 2, 3, 4];
        } else {
          this.contentAuditStatusList = [contentStatus];
        }
        this.select.map((item) => {
          if (item.prop == "writeDoc") {
            item.List = doctorList;
          }
        });
      } else {
        this.paginationDataProduct.currentPage = 1;
        this.selectList.queryItem = "";
        this.selectList.businessLabel = "";
        this.selectList.selectDiseaseInfoId1 = "";
        this.selectList.submissionTime = [];
        this.selectList.contentStatus = "";
        this.selectList.selectedDeparttId = null;
        this.selectList.writeDoc = null;
        this.activeName = "all";
        this.auditStatus = [1, 2, 3, 4];
        this.select.map((item) => {
          if (item.prop == "writeDoc") {
            item.List = [];
          }
        });
      }
    },
    doctorInfosOrDoctor(data, type) {
      let doctorInformation = "";
      data.map((item) => {
        item.roleType == 2
          ? (doctorInformation =
              item.docName +
              " " +
              item.titleName +
              " " +
              "ID: " +
              item.docId +
              " " +
              item.hospitalGradeName +
              " " +
              item.hospitalName +
              " " +
              item.departName)
          : "";
      });
      return doctorInformation;
    },
    // 查看线上
    articlePreview(row, route) {
      const isDev = process.env.VUE_APP_BASEURL == "//beta-api.m.jd.com";
      let betaUrl = "https://cont-yf.healthjd.com/wiki/";
      let onlineUrl = "https://cont.healthjd.com/wiki/";
      window.open(`${isDev ? betaUrl : onlineUrl}${route}/${row.contentId}`);
      // window.open(`http://dev.healthjd.com:3000/wiki/healthcare/${row.contentId}`);
    },
    remarkContent(i) {
      if (i.row.statusInfo) {
        this.reasonForOffline = i.row.statusInfo.remark;
      } else {
        this.reasonForOffline = "";
      }
    },
    handleClick(tab, event) {
      if (tab.name == "all") {
        this.articleListCode = 0;
      } else if (tab.name === "unaudit") {
        this.articleListCode = 2;
      } else if (tab.name === "approved") {
        this.articleListCode = 3;
      } else if (tab.name === "rejected") {
        this.articleListCode = 4;
      }
      if (this.articleListCode !== 0) {
        this.contentAuditStatusList.splice(
          0,
          this.contentAuditStatusList.length
        );
        this.contentAuditStatusList.push(this.articleListCode);
      } else {
        this.contentAuditStatusList = [1, 2, 3, 4];
      }
      this.pageDiseaseInfoDraftList("1");
      this.getDiseaseDraftCountList();
    },
    // 查询文章
    getChangeValue(data) {
      if (this.$utils.checkNumber(data.queryItem)) {
        this.pageDiseaseInfoDraftList("1");
        this.getDiseaseDraftCountList();
      } else {
        this.$message({
          message: "ID只能为数字",
          type: "warning",
        });
      }
    },
    // 跳转审核页
    toAuditPage(data, croute) {
      this.$router.push({
        path: "/wikiManage/commonwikiEdit",
        query: {
          id: data.contentId,
          contentType: this.contentType,
          type: data.contentType,
          croute,
        },
      });
      // 2025/01/10 夜谜审核-希望开新页面而不是直接跳转
      // const url = this.$router.resolve({
      //   path: `/wikiManage/commonwikiEdit`,
      //   query: {
      //     id: data.contentId,
      //     contentType: this.contentType,
      //     type: data.contentType,
      //     croute,
      //   }
      // }).href;
      // window.open(url, '_blank');
      this.setStorage();
    },
    // 跳转编辑页
    toEditPage(data, croute) {
      this.$router.push({
        path: "/wikiManage/commonwikiEdit",
        query: {
          id: data.contentId,
          contentType: this.contentType,
          actionType: 1,
          type: data.contentType,
          croute,
        },
      });
      // 2025/01/10 夜谜审核-希望开新页面而不是直接跳转
      // const url = this.$router.resolve({
      //   path: `/wikiManage/commonwikiEdit`,
      //   query: {
      //     id: data.contentId,
      //     contentType: this.contentType,
      //     actionType: 1,
      //     type: data.contentType,
      //     croute,
      //   }
      // }).href;
      // window.open(url, '_blank');
      this.setStorage();
    },
    // 跳转存储信息
    setStorage() {
      // 跳转页面存储当前页码
      sessionStorage.setItem(
        "currentPage",
        this.paginationDataProduct.currentPage
      );
      sessionStorage.setItem("contentAuditStatus", this.contentAuditStatusList);
      sessionStorage.setItem("activeName", this.activeName);
      let selectStr = JSON.stringify(this.selectList);
      sessionStorage.setItem("select", selectStr);
      this.select.map((item) => {
        if (item.prop == "writeDoc") {
          let doctorArr = JSON.stringify(item.List);
          sessionStorage.setItem("writeDoc", doctorArr);
        }
      });
    },
    // /wikiManage/wikiEdit
    // 查看理由
    seeReason(data) {
      this.seeReasonDialog = true;
      this.reason = data.auditInfo.remark;
    },
    // 下线文章
    offlineDisease(data) {
      this.offLineReasons = "";
      this.offlineDialog = true;
      this.getOffLineInfo(data);
    },
    getOffLineInfo(data) {
      this.offLineInfo = data;
    },
    // 下线
    offlineClickHandler(type) {
      if (type == "one") {
        this.offlineDialog = false;
      } else if (type == "two") {
        if (this.offLineReasons === "") {
          this.$message.error("请输入下线理由");
          return;
        }
        // this.offlineDialog = true
        changgeDiseaseSymptomsOnline({
          contentId: this.offLineInfo.contentId,
          tenantId: this.$commonJs.getTenantId(),
          contentStatus: 2,
          contentType: this.$route.query.type,
          remark: this.offLineReasons,
        }).then((res) => {
          this.$message.success("下线成功");
          this.offlineDialog = false;
          this.pageDiseaseInfoDraftList();
        });
      }
    },
    getParams() {
      let contentDoctorBizParams = [];
      if (this.selectList.writeDoc) {
        contentDoctorBizParams.push({
          docId: this.selectList.writeDoc,
          roleType: 1,
        });
      }
      // debugger;
      if (this.selectList.editorialDoctor) {
        contentDoctorBizParams.push({
          docId: this.selectList.editorialDoctor,
          roleType: 2,
        });
      }
      let departIds = [];
      if (this.selectList?.departmentName?.length > 0) {
        departIds = this.selectList?.departmentName?.map(
          (item) => item[item?.length - 1]
        );
      }
      let params;
      return (params = {
        contentType: this.contentType,
        contentId: this.selectList.queryItem || null,
        labelIds: this.selectList.businessLabel || null,
        contentDoctorBizParams: contentDoctorBizParams || [],
        aliasNamePrecise: this.selectList.selectDiseaseInfoId1 || null,
        contentStatus: this.selectList.contentStatus
          ? [this.selectList.contentStatus]
          : [],
        bodyPartId: this.selectList.selectedDeparttId || null,
        // departIds:
        //   this.selectList.departmentName == []
        //     ? []
        //     : [...new Set(this.selectList.departmentName?.flat(Infinity))],
        departIds,
        tenantId: this.$commonJs.getTenantId(),
        startTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[0]) ||
          null,
        endTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[1]) ||
          null,
        auditStatus: [1, 2, 3, 4],
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      });
    },
    // 获取各种状态的数量
    getDiseaseDraftCountList() {
      let params = this.getParams();
      getReviewStatus(params).then((res) => {
        this.jbbkTabList.forEach((item) => {
          item.count = res[item.type];
        });
      });
    },
    getBusinessLabelList() {
      return new Promise((resolve, reject) => {
        if (this.businessLabelList.length == 0) {
          request("health_cmp_biz_pageAuditLabels", {
            tenantId: this.$commonJs.getTenantId(),
          })
            .then((res) => {
              this.businessLabelList = res.data || [];
              resolve(this.businessLabelList);
            })
            .catch((err) => {
              reject(err);
            });
        } else {
          resolve(this.businessLabelList);
        }
      });
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageDiseaseInfoDraftList();
    },
    // 获取症状百科列表数据1
    pageDiseaseInfoDraftList(val) {
      if (val == "1") {
        this.paginationDataProduct.currentPage = 1;
      }
      var patrn = /[0-9]/im;
      if (this.selectList.queryItem && !patrn.test(this.selectList.queryItem)) {
        return this.$message.error("请填写正确的ID");
      }
      let params = this.getParams();
      params.auditStatus = this.contentAuditStatusList;
      getDiseaseSymptoms(params).then((res) => {
        this.jbbkList.splice(0, this.jbbkList.length);
        if (res.data) {
          res.data.map((item) => {
            this.jbbkList.push(item);
          });
        } else {
          this.jbbkList = [];
        }
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
      });
    },
    handleDialog(val) {
      this.seeReasonDialog = val;
    },
    offlineDialogHandel(data) {
      this.offlineDialogShow = data;
    },
    // 清空筛选
    empty() {
      Object.keys(this.selectList).map((item) => {
        this.selectList[item] = "";
      });
      this.select.map((item) => {
        if (item.prop == "writeDoc") {
          item.List = [];
        }
        if (item.prop == "editorialDoctor") {
          item.List = [];
        }
      });
      this.pageDiseaseInfoDraftList();
      this.getDiseaseDraftCountList();
    },
    // 获取部位
    healthCmpQueryBodyParts() {
      healthCmpQueryBodyParts({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        let arr = [];
        res.data.map((items) => {
          arr.push({
            value: items.id,
            label: items.name,
          });
        });
        this.select.map((item) => {
          if (item.prop == "selectedDeparttId") {
            item.List.splice(0, item.List.length);
            item.List = arr;
          }
        });
      });
    },
    editorial_remoteMethod(val) {
      getDoctorInformation({
        tenantId: this.$commonJs.getTenantId(),
        doctorName: val,
      })
        .then((res) => {
          let arr = res.map((itemRes) => {
            return {
              value: itemRes.docId,
              label:
                itemRes.docName +
                " " +
                itemRes.titleName +
                " " +
                itemRes.hospitalGradeName +
                " " +
                itemRes.hospitalName +
                " " +
                itemRes.departName,
            };
          });
          this.select.map((item) => {
            if (item.prop == "editorialDoctor") {
              item.List.splice(0, item.List.length);
              item.List = arr;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    write_remoteMethod(val) {
      getDoctorInformation({
        tenantId: this.$commonJs.getTenantId(),
        doctorName: val,
      })
        .then((res) => {
          let arr = res.map((itemRes) => {
            return {
              value: itemRes.docId,
              label:
                itemRes.docName +
                " " +
                itemRes.titleName +
                " " +
                itemRes.hospitalGradeName +
                " " +
                itemRes.hospitalName +
                " " +
                itemRes.departName,
            };
          });
          this.select.map((item) => {
            if (item.prop == "writeDoc") {
              item.List.splice(0, item.List.length);
              item.List = arr;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleExportDataClose() {
      if (this.isUploading) return;
      this.showExportData = false;
      this.exportFile = null;
    },
    handleUploadDataClose() {
      this.showUploadData = false;
    },
    downloadTemplate() {
      getImportTemplate({
        contentType: this.contentType,
        importExportCode: this.importExportCode,
      })
        .then((result) => {
          const { templateUrl } = result;
          const excelUrl = templateUrl.replace(
            "http://storage.jd.local",
            "https://storage.360buyimg.com"
          );
          window.location.href = excelUrl;
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    onSelectFile() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept =
        ".xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel";
      input.onchange = (evt) => {
        this.exportFile = evt.target.files[0];
      };
      input.click();
    },
    formatFileName(name) {
      const fnameArr = name.split(".");
      return (
        (fnameArr[0].length > 10
          ? `${fnameArr[0].slice(0, 6)}...${fnameArr[0].slice(-4)}`
          : fnameArr[0]) +
        "." +
        fnameArr[1]
      );
    },
    onUploadFile() {
      if (!this.exportFile) {
        this.$message.error("请先选择文件");
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(this.exportFile);
      reader.onload = (evt) => {
        const fileBase64 = evt.target.result.replace(
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
          ""
        );
        const param = {
          tenantId: this.$commonJs.getTenantId(),
          fileBase64,
          importExportCode: this.importExportCode,
          contentType: this.contentType,
          fileName: this.formatFileName(this.exportFile.name),
        };
        this.isUploading = true;
        importInArticleCategory(param)
          .then((result) => {
            const roundCheck = () => {
              this.checkExportProcess(this.importExportCode, (result) => {
                if ([1, 2].includes(result.importExportStatus)) {
                  setTimeout(() => roundCheck(), 1000);
                } else {
                  this.isUploading = false;
                  if (result.importExportStatus === 3) {
                    this.$message.success("导入成功");
                    this.pageDiseaseInfoDraftList();
                  } else {
                    this.$message.error("导入失败");
                  }
                  this.showExportData = false;
                }
              });
            };
            roundCheck();
          })
          .catch((err) => {
            this.isUploading = false;
            this.$message.error(err.msg);
          });
      };
    },
    checkExportProcess(code, callback) {
      const param = {
        importExportCode: code,
        importExportType: 1,
      };
      importExportLog(param)
        .then((result) => {
          callback(result);
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    exportFailData(code) {
      this.checkExportProcess(code, (result) => {
        if (result && result.failFileUrl) {
          const excelUrl = result.failFileUrl.replace(
            "http://storage.jd.local",
            "https://storage.360buyimg.com"
          );
          window.location.href = excelUrl;
        } else {
          this.$message.error("暂无失败数据");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wiki-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
  position: relative;
  .btn-bar {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

.freezeDom {
  margin-top: 30px;

  .freezeInp {
    max-height: 280px;
    max-width: 276px;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  :deep(.el-textarea__inner) {
    min-height: 145px !important;
    max-height: 280px !important;
  }

  :deep(.el-form-item__label) {
    line-height: 15px;
  }

  .mar-top30 {
    margin-top: 30px;
  }
}

:deep(.cell) {
  font-size: 13px;
  color: rgba(93, 96, 114, 1);
}

.base-dialog {
  width: 400px;
  padding: 30px 26px 30px 26px !important;
  font-size: 14px;
  color: #2c3443;
}

.red {
  margin-left: 24px;
  position: absolute;
  color: red;
}

.rejected:hover {
  cursor: pointer;
  color: red;
}
:deep(.el-cascader) {
  width: 100%;
  height: 32px;
}
</style>
